module.exports = __webpack_public_path__ + "img/orgDetail_1.6092e11f.png";